<template>
  <SGPModalComponent
    titulo="Regras Externas"
    icon="mdi-relation-many-to-many"
    tamanho="full"
    @sgpModalFechar="$emit('fecharModalRegrasExternas', true)"
  >
    <div class="wrapper-regra-externa">
      <div class="coluna-regra-externa">
        <SGPFormInputComponent
        class="mb-3"
        label="Filtrar campos"
        stylized
        v-model="buscarCampos"
        ></SGPFormInputComponent>

        <span class="title">Campos</span>
        <p>Lista de campos inseridos dentro do formulário.</p>

        <div v-for="linha in form" :key="linha">
          <div
            v-for="campo in linha.campos.filter(filtrarCampos)"
            :key="campo"
            :class="`d-flex align-items-center campo ${ campoSelecionado && campoSelecionado?.ctrl_campo == campo.ctrl_campo ? 'ativo' : 'inativo' }`"
            clickable
            @click="selecionaCampo(campo)">
            <span :class="`mr-3`" >
              <SGPIconComponent :color="`${ campoSelecionado?.ctrl_campo ==  campo.ctrl_campo ? 'white' : '' }`">
                mdi-{{ campoSelecionado?.ctrl_campo ==  campo.ctrl_campo ? 'radiobox-marked' : 'radiobox-blank' }}
              </SGPIconComponent>
            </span>
            <span>
            {{ campo.ctrl_campo.label }} <small>{{ campo.ctrl_campo.tipo_campo }} </small>
            </span>
          </div>
        </div>
      </div>

      
      <div class="d-flex">
        <div
          v-if="campoSelecionado?.ctrl_campo.tipo_campo == 'select'"
          class="coluna-regra-externa blue lighten-5 mr-4"
          style="width: 44%;"
        >
          <span class="title">Opções</span>
          <div
            v-for="opcao in campoSelecionado.ctrl_campo.options"
            :key="opcao"
            :class="`d-flex align-items-center linha-opcao ${ opcaoEstaAtiva(opcao) ? 'opcao-ativa' : ''}`"
            clickable
            @click="selecionarOpcao(opcao)"
          >
            <SGPIconComponent class="mr-2">
               mdi-{{ opcaoEstaAtiva(opcao) ? 'radiobox-marked' : 'radiobox-blank' }}
            </SGPIconComponent>
            {{ opcao.label }}
          </div>

        </div>
        <div class="coluna-regra-externa blue-grey lighten-5">
          <span class="title">Buscador de dados </span>
          <div class="d-flex">
            <SGPFormInputComponent v-model="pco_tarefa_id"></SGPFormInputComponent>
            <SGPFormBotaoComponent
              :rounded="false"
              class="ml-5"
              @click="buscarDados"
            >
              <SGPIconComponent>mdi-magnify</SGPIconComponent>
              Buscar Ficha
            </SGPFormBotaoComponent>
          </div>
          <p>
            Adicione o id da Pco Tarefa para listar os dados da ficha técnica, lembre-se que esses dados funcionarão como teste 
            no funcinamento do formuário, não atualize a página pois esses dados serão perdidos.
          </p>

          <p class="text-primary">OBS: Para criar uma regra com a variavel escolhida, basta clicar duas vezes ancima.</p>
          
          <div class="d-flex" v-if="dadosFiltrados.length">
            <SGPFormInputComponent
            class="mb-3 mr-4"
            placeholder="Filtrar variaveis"
            v-model="search"
            ></SGPFormInputComponent>

            <SGPFormBotaoComponent @click="buscarDadosTreeView">Buscar</SGPFormBotaoComponent>
          </div>

          <SGPTreeViewComponent
            @sgpTreeClick="adicionarDado"
            :nodes="dadosFiltrados"
            v-if="dadosFiltrados.length" />

          <!-- <v-treeview
            v-if="dadosFiltrados.length"
            :hide-actions="!actionIcons"
            :indent-lines="indentLines"
            :items="dadosFiltrados"
            :separate-roots="separateRoots"
            density="compact"
            item-value="path"
            item-text="label"
            item-children="children"
            open-on-click
            fluid 
          >
            <template v-slot:prepend="{ item, isOpen }">
              <v-icon :icon="getIcon(item, isOpen)"></v-icon>
            </template>

            <template v-slot:label="{item}">
              <div v-on:dblclick="adicionarDado(item)" class="mt-1 mb-1">
                {{ item.label }} <br/><small>{{ item.value }}</small>
              </div>
            </template>
          </v-treeview>         -->
        </div>
      </div>

      <div class="coluna-regra-externa brown lighten-5" v-if="campoSelecionado">
        <div class="d-flex justify-content-space-between">
          <span class="title">
            Regras do campo:
            <span class="subtitle">{{ campoSelecionado?.ctrl_campo.label }}</span>
          </span>

          <SGPFormBotaoComponent fab x-small color="grey lighten-5">
            <span class="font-size-16">{{ campoSelecionado?.expressoes_logicas_externas.length }}</span>
          </SGPFormBotaoComponent>
        </div>

        <div
          class="linha-regra"
          v-for="(regra, i) in campoSelecionado?.expressoes_logicas_externas"
          :key="regra.path"
        >
          <div style="width: 100%;">
            <SGPFormSelectComponent
              v-if="i"
              :listaDeOptions="operadorLogico"
              optionValue="value"
              v-model="regra.operador_logico"
              placeholder="Operador Lógico"
            />

            <SGPFormInputComponent
              v-model="regra.path"
              class=""
              disabled
            />

            <SGPFormAutocompleteComponent
              :listaDeOptions="listaDeExpressoes"
              optionLabel="expressao"
              v-model="regra.ctrl_expressao_booleana"
              solo
              placeholderText="Tipo do campo"
              style="width: 100%;"
              class=""
              mostrarSelecione
              retornarObjeto
            />

            <SGPFormInputComponent
              v-model="regra.value"
              class=""
            />

            <small>{{ regra.option_value }}</small>
          </div>
          <div>
            <SGPFormBotaoComponent fab small text @click="deletarRegraExterna(i, regra)">
              <SGPIconComponent>mdi-delete</SGPIconComponent>
            </SGPFormBotaoComponent>
          </div>
        </div>
      </div>
      
      
    </div>
    <div class="mt-3 mb-2 text-right" style="width: 100%;">
      <SGPFormBotaoComponent @click="adicionarRegrasExternasAoCampo()">
        <SGPIconComponent>mdi-plus</SGPIconComponent>
        Adicionar Regra
      </SGPFormBotaoComponent>
    </div>
  </SGPModalComponent>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import criarToast from '@/common/boot/ToastsHandler'

export default {
  name: "RegrasExternasComponent",
  props: {
    mostrarModalRegrasExternas: {
      type: Boolean,
      required: true,
      default: false
    },

    form: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      campoSelecionado: null,
      dadosExternos: null,
      pco_tarefa_id: null,
      dadosFiltrados: [],
      tree: null,
      separateRoots: false,
      actionIcons: true,
      prependIcons: true,
      search: '',
      open: [1,2],
      optionSelecionado: [],
      regras: [],
      buscarCampos: '',
      operadorLogico: [
        { name: 'E', value: '&&'},
        { name: 'OU', value: '||'}
      ]
    }
  },

  created () {
    // setTimeout(() => {
    //   const dadosExternos = localStorage.getItem('form_dinamico_dado_externo')
    //   if (dadosExternos) {
    //     this.dadosExternos = JSON.parse(dadosExternos)
    //     this.pco_tarefa_id = this.dadosExternos.pco_tarefa_id
    //   }
    // }, 1000)
  },

  computed: {
    ...mapGetters('fichaTecnicaWorkflow', [
      'loadingFichaTecnica',
      'dadosFichaTecnica'
    ]),

    ...mapGetters('ctrlFormularioDinamico', [
      'listaDeExpressoesBooleanas'
    ]),

    listaDeExpressoes () {
      if (this.listaDeExpressoesBooleanas) {
        return this.listaDeExpressoesBooleanas
      }
      return []
    },
  },

  methods: {
    ...mapActions('fichaTecnicaWorkflow', [
      'salvarDadosFormulario',
      'buscarDadosFichaTecnica',
      'limparFichaTecnica',
      'buscarDadosHistoricoFichaTecnica',
      'listarCircuitoPcoTarefasLog',
      'listaDadosFichaTecnicaAdocao',
      'desfazerBloco'
    ]),
    selecionaCampo(campo) {
      this.campoSelecionado = {...campo}
      this.optionSelecionado = []
    },

    selecionarOpcao(opcao) {
      const existe = this.optionSelecionado.findIndex(o => o.val == opcao.val)
      if (existe != -1) {
        this.optionSelecionado.splice(existe, 1)
        return
      }

      this.optionSelecionado.push({
        ...opcao,
        ativo: true
      })
    },

    opcaoEstaAtiva (opcao) {
      const existe = this.optionSelecionado.find(o => o.val == opcao.val)
      return existe ? true : false
    },

    async buscarDados () {
      const dados = await this.buscarDadosFichaTecnica(this.pco_tarefa_id)
      this.dadosExternos = dados.data.data
      localStorage.setItem('form_dinamico_dado_externo', JSON.stringify(this.dadosExternos))
    },

    objectToTree(obj, parentPath = '') {
      const result = [];

      for (const key in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;

        const value = obj[key];
        const currentPath = Array.isArray(obj)
          ? `${parentPath}[${key}]`
          : parentPath
          ? `${parentPath}.${key}`
          : key;

        if (typeof value === 'object' && value !== null) {
          if (Array.isArray(value)) {
            result.push({
              label: key,
              path: currentPath,
              children: value.map((item, index) => {
                const itemPath = `${currentPath}[${index}]`;
                if (typeof item === 'object') {
                  return {
                    label: `[${index}]`,
                    path: itemPath,
                    children: this.objectToTree(item, itemPath)
                  };
                } else {
                  return {
                    label: `[${index}]`,
                    value: item,
                    path: itemPath
                  };
                }
              })
            });
          } else {
            result.push({
              label: key,
              path: currentPath,
              children: this.objectToTree(value, currentPath)
            });
          }
        } else {
          result.push({
            label: key,
            value,
            path: currentPath
          });
        }
      }

      return result
    },

    getIcon (item, isOpen) {
      if (item.children) return isOpen ? 'mdi-folder-open' : 'mdi-folder'
      return 'mdi-file-arrow-up-down-outline'
    },

    adicionarDado (item) {
      if (Array.isArray(item.children) && item.children.length > 0) return

      if (!this.campoSelecionado) {
        criarToast({
          tipo: 'error',
          mensagem: 'Escolha um campo para adicionar a regra!'
        })
        return 
      }

      let jaExisteEssaRegra = false
      this.regras.forEach(regra => {
        jaExisteEssaRegra = regra.path == item.path
      })

      if (jaExisteEssaRegra) {
        criarToast({
          tipo: 'warning',
          mensagem: 'Essa regra já existe!'
        })
        return
      }

      this.campoSelecionado.expressoes_logicas_externas.push({
        operador_logico: this.campoSelecionado.expressoes_logicas_externas.length ? '&&' : '',
        path: item.path,
        label: item.label,
        value: item.value,
        options: this.optionSelecionado.length ? [...this.optionSelecionado] : null,
        option_value: this.optionSelecionado.length ? [...this.optionSelecionado.map(option => option.val)].join(',') : null,
        ctrl_expressao_booleana: null,
        ctrl_campo_id: this.campoSelecionado.ctrl_campo.id,
        name: this.campoSelecionado.ctrl_campo.name
      })

      criarToast({
        tipo: 'success',
        mensagem: `Regra (${item.label}) adicionada!`,
        duracao: 3000
      })
    },

    deletarRegraExterna (i, item) {
      this.campoSelecionado.expressoes_logicas_externas.splice(i, 1)
      criarToast({
        tipo: 'success',
        mensagem: `Regra (${item.label}) deletada com sucesso!`,
        duracao: 3000
      })

      if (this.campoSelecionado.expressoes_logicas_externas.length) {
        this.campoSelecionado.expressoes_logicas_externas[0].operador_logico = ""
      }
    },

    filterTree(tree, searchTerm) {
      // Converte o termo de busca para minúsculas para uma comparação sem distinção entre maiúsculas e minúsculas
      const lowerCaseSearchTerm = searchTerm.toLowerCase();

      return tree.reduce((accumulator, node) => {
        // 1. Verifica se o nó atual corresponde ao termo de busca
        const nodeMatches = 
          node.label && node.label.toLowerCase().includes(lowerCaseSearchTerm) ||
          (node.value && String(node.value).toLowerCase().includes(lowerCaseSearchTerm));
        
        // 2. Procura por correspondências nos filhos do nó
        const childrenMatches = node.children ? this.filterTree(node.children, searchTerm) : [];

        // 3. Se o nó atual ou algum de seus filhos corresponder, adiciona o nó à nova árvore
        if (nodeMatches || childrenMatches.length > 0) {
          // Cria um novo nó com os filhos filtrados
          const newNode = { ...node, children: childrenMatches };
          accumulator.push(newNode);
        }
        
        return accumulator;
      }, []);
    },

    adicionarRegrasExternasAoCampo () {
      console.log('Adicionar regra do campo ao formulario: ', this.campoSelecionado, this.form)

      if (!this.campoSelecionado) return
      if (this.campoSelecionado && !this.campoSelecionado.expressoes_logicas_externas.length)  return

      this.form.forEach(linha => {
        linha.campos.forEach(campo => {          
          if (campo.ctrl_campo_id == this.campoSelecionado.ctrl_campo_id) {
            campo.expressoes_logicas_externas = this.campoSelecionado.expressoes_logicas_externas
          }
        })
      })
    },

    filtrarCampos(campo) {
      if (this.buscarCampos)
        return campo.ctrl_campo.label.toLowerCase().includes(this.buscarCampos.toLowerCase())
      return true
    },
    
    buscarDadosTreeView () {
      const val = this.search
      if (val.length >= 2) {
        this.dadosFiltrados = [...this.filterTree(this.tree, val)]
        return
      }      
      this.dadosFiltrados = [...this.tree]
    }
  },

  watch: {
    dadosExternos () {   
      if (this.dadosExternos) {
        this.tree = [...this.objectToTree(this.dadosExternos)]
        this.dadosFiltrados = this.tree
      }
    },    
  }
}
</script>

<style lang="scss">

.wrapper-regra-externa {
  display: grid;
  grid-template-columns: 0.8fr 2fr 1fr;
  gap: 15px;
  overflow: hidden; 

  .coluna-regra-externa {
    border: solid 1px #eee;
    border-radius: 8px;
    padding: 10px;
    width: 100%;
    overflow: auto;
    max-height: 70vh;

    .title {
      font-size: 20px !important;
      font-weight: 500;
      color: #333;
      line-height: 22px;

      .subtitle {
        display: block;
        font-size: 16px !important;
        font-weight: 300;
      }
    }

    .campo {
      padding: 8px 10px;
      font-weight: 500;
      border: solid 1px #512DA8;
      border-radius: 4px;
      margin-bottom: 8px;
      font-size: 15px;
      cursor: pointer;
      transition: all 0.3s;
      line-height: 18px;
      color: #512DA8;

      .v-icon.v-icon {
        color: #512DA8;
      }
      
      small { display: block; font-weight: 300; font-size: 12px;}
      
      &:hover {
        // box-shadow: 0px 0px 8px 2px rgba(0,0,0,0.38);
        background: #5E35B1;
        color: #fff;
        border: solid 1px #5E35B1;

        .v-icon.v-icon {
          color: #fff;
        }
      }
    } 

    .linha-opcao {
      padding: 8px 10px;
      font-weight: 500;
      border: solid 1px #8861e2;
      color: #8861e2;
      border-radius: 4px;
      margin-top: 5px;
      cursor: pointer;
      transition: all 0.3s;
      .v-icon.v-icon {
          color: #8861e2;
        }

      &:hover {
        // box-shadow: 0px 0px 8px 2px rgba(0,0,0,0.38);
        background: #8861e2;
        color: #fff;
        border: solid 1px #8861e2;

        .v-icon.v-icon {
          color: #fff !important;
        }
      }
    }

    .opcao-ativa {
      background: #8861e2;
      color: #fff;
      border: solid 1px #8861e2;
      .v-icon.v-icon {
        color: #fff !important;
      }
    }
    
    .ativo {
      background: #5E35B1;
      color: #fff;
      border: solid 1px #5E35B1;
      // box-shadow: 0px 0px 8px 2px rgba(0,0,0,0.38);
    }

    .linha-regra {
      display: flex;
      // justify-items: center;
      align-items: center;
      gap: 4px;
      border: solid 1px #ddd;
      padding: 10px;
      border-radius: 8px;
      margin-top: 10px;
      background: #fff;


      // input, select, option {
      //   font-size: 12px !important;
      //   width: 100% !important;
      // }
    }
  }
}

</style>